/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ESearchFilter,
  EntityNotFoundErrorDetailsErrorResponseModel,
  GetAllOrdersFilterSortDto,
  OrderDashboardStatsDto,
  OrderDto,
  OrderDtoPagedResponseDto,
  OrderTotal,
  RequiredFieldsMissingErrorDetailsErrorResponseModel,
  SortDirection,
  YearlyMetricsDto,
  YearsResponse,
} from '../models/index';
import {
    ESearchFilterFromJSON,
    ESearchFilterToJSON,
    EntityNotFoundErrorDetailsErrorResponseModelFromJSON,
    EntityNotFoundErrorDetailsErrorResponseModelToJSON,
    GetAllOrdersFilterSortDtoFromJSON,
    GetAllOrdersFilterSortDtoToJSON,
    OrderDashboardStatsDtoFromJSON,
    OrderDashboardStatsDtoToJSON,
    OrderDtoFromJSON,
    OrderDtoToJSON,
    OrderDtoPagedResponseDtoFromJSON,
    OrderDtoPagedResponseDtoToJSON,
    OrderTotalFromJSON,
    OrderTotalToJSON,
    RequiredFieldsMissingErrorDetailsErrorResponseModelFromJSON,
    RequiredFieldsMissingErrorDetailsErrorResponseModelToJSON,
    SortDirectionFromJSON,
    SortDirectionToJSON,
    YearlyMetricsDtoFromJSON,
    YearlyMetricsDtoToJSON,
    YearsResponseFromJSON,
    YearsResponseToJSON,
} from '../models/index';

export interface OrdersGetAllOrdersPOSTRequest {
    getAllOrdersFilterSortDto?: GetAllOrdersFilterSortDto;
}

export interface OrdersGetAvailableYearsForBusinessUnitsGETRequest {
    years?: string;
    businessUnitId?: string;
}

export interface OrdersGetAvailableYearsForCategoriesGETRequest {
    years?: string;
    categoryId?: string;
}

export interface OrdersGetAvailableYearsGETRequest {
    years?: string;
    companyId?: string;
}

export interface OrdersGetBusinessUnitsOrdersForSelectedYearsGETRequest {
    businessUnitId?: string;
    selectedYears?: Array<number>;
    searchSearch?: string;
    searchSearchValue?: string;
    searchSearchFilter?: ESearchFilter;
    pagingPageIndex?: number;
    pagingPageSize?: number;
    sortingSortBy?: string;
    sortingSortDir?: SortDirection;
}

export interface OrdersGetCategoryOrdersForSelectedYearsGETRequest {
    categoryId?: string;
    selectedYears?: Array<number>;
    searchSearch?: string;
    searchSearchValue?: string;
    searchSearchFilter?: ESearchFilter;
    pagingPageIndex?: number;
    pagingPageSize?: number;
    sortingSortBy?: string;
    sortingSortDir?: SortDirection;
}

export interface OrdersGetCompanyOrdersForSelectedYearsGETRequest {
    companyId?: string;
    selectedYears?: Array<number>;
    searchSearch?: string;
    searchSearchValue?: string;
    searchSearchFilter?: ESearchFilter;
    pagingPageIndex?: number;
    pagingPageSize?: number;
    sortingSortBy?: string;
    sortingSortDir?: SortDirection;
}

export interface OrdersGetDashboardStatsGETRequest {
    startDate?: Date;
    endDate?: Date;
}

export interface OrdersGetOrderByIdGETRequest {
    id: string;
}

export interface OrdersGetOrderTotalsGETRequest {
    orderId?: string;
    year?: number;
}

export interface OrdersGetYearlyBusinessUnitMetricsGETRequest {
    businessUnitId?: string;
    years?: Array<number>;
}

export interface OrdersGetYearlyCategoryMetricsGETRequest {
    categoryId?: string;
    years?: Array<number>;
}

export interface OrdersGetYearlyCompanyMetricsGETRequest {
    companyId?: string;
    years?: Array<number>;
}

/**
 * OrdersApi - interface
 * 
 * @export
 * @interface OrdersApiInterface
 */
export interface OrdersApiInterface {
    /**
     * Creates request options for ordersGetAllOrdersPOST without sending the request
     * @param {GetAllOrdersFilterSortDto} [getAllOrdersFilterSortDto] 
     * @throws {RequiredError}
     * @memberof OrdersApiInterface
     */
    ordersGetAllOrdersPOSTRequestOpts(requestParameters: OrdersGetAllOrdersPOSTRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {GetAllOrdersFilterSortDto} [getAllOrdersFilterSortDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApiInterface
     */
    ordersGetAllOrdersPOSTRaw(requestParameters: OrdersGetAllOrdersPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrderDtoPagedResponseDto>>;

    /**
     */
    ordersGetAllOrdersPOST(requestParameters: OrdersGetAllOrdersPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrderDtoPagedResponseDto>;

    /**
     * Creates request options for ordersGetAvailableYearsForBusinessUnitsGET without sending the request
     * @param {string} [years] 
     * @param {string} [businessUnitId] 
     * @throws {RequiredError}
     * @memberof OrdersApiInterface
     */
    ordersGetAvailableYearsForBusinessUnitsGETRequestOpts(requestParameters: OrdersGetAvailableYearsForBusinessUnitsGETRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {string} [years] 
     * @param {string} [businessUnitId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApiInterface
     */
    ordersGetAvailableYearsForBusinessUnitsGETRaw(requestParameters: OrdersGetAvailableYearsForBusinessUnitsGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<YearsResponse>>;

    /**
     */
    ordersGetAvailableYearsForBusinessUnitsGET(requestParameters: OrdersGetAvailableYearsForBusinessUnitsGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<YearsResponse>;

    /**
     * Creates request options for ordersGetAvailableYearsForCategoriesGET without sending the request
     * @param {string} [years] 
     * @param {string} [categoryId] 
     * @throws {RequiredError}
     * @memberof OrdersApiInterface
     */
    ordersGetAvailableYearsForCategoriesGETRequestOpts(requestParameters: OrdersGetAvailableYearsForCategoriesGETRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {string} [years] 
     * @param {string} [categoryId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApiInterface
     */
    ordersGetAvailableYearsForCategoriesGETRaw(requestParameters: OrdersGetAvailableYearsForCategoriesGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<YearsResponse>>;

    /**
     */
    ordersGetAvailableYearsForCategoriesGET(requestParameters: OrdersGetAvailableYearsForCategoriesGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<YearsResponse>;

    /**
     * Creates request options for ordersGetAvailableYearsGET without sending the request
     * @param {string} [years] 
     * @param {string} [companyId] 
     * @throws {RequiredError}
     * @memberof OrdersApiInterface
     */
    ordersGetAvailableYearsGETRequestOpts(requestParameters: OrdersGetAvailableYearsGETRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {string} [years] 
     * @param {string} [companyId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApiInterface
     */
    ordersGetAvailableYearsGETRaw(requestParameters: OrdersGetAvailableYearsGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<YearsResponse>>;

    /**
     */
    ordersGetAvailableYearsGET(requestParameters: OrdersGetAvailableYearsGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<YearsResponse>;

    /**
     * Creates request options for ordersGetBusinessUnitsOrdersForSelectedYearsGET without sending the request
     * @param {string} [businessUnitId] 
     * @param {Array<number>} [selectedYears] 
     * @param {string} [searchSearch] 
     * @param {string} [searchSearchValue] 
     * @param {ESearchFilter} [searchSearchFilter] 
     * @param {number} [pagingPageIndex] 
     * @param {number} [pagingPageSize] 
     * @param {string} [sortingSortBy] 
     * @param {SortDirection} [sortingSortDir] 
     * @throws {RequiredError}
     * @memberof OrdersApiInterface
     */
    ordersGetBusinessUnitsOrdersForSelectedYearsGETRequestOpts(requestParameters: OrdersGetBusinessUnitsOrdersForSelectedYearsGETRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {string} [businessUnitId] 
     * @param {Array<number>} [selectedYears] 
     * @param {string} [searchSearch] 
     * @param {string} [searchSearchValue] 
     * @param {ESearchFilter} [searchSearchFilter] 
     * @param {number} [pagingPageIndex] 
     * @param {number} [pagingPageSize] 
     * @param {string} [sortingSortBy] 
     * @param {SortDirection} [sortingSortDir] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApiInterface
     */
    ordersGetBusinessUnitsOrdersForSelectedYearsGETRaw(requestParameters: OrdersGetBusinessUnitsOrdersForSelectedYearsGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrderDtoPagedResponseDto>>;

    /**
     */
    ordersGetBusinessUnitsOrdersForSelectedYearsGET(requestParameters: OrdersGetBusinessUnitsOrdersForSelectedYearsGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrderDtoPagedResponseDto>;

    /**
     * Creates request options for ordersGetCategoryOrdersForSelectedYearsGET without sending the request
     * @param {string} [categoryId] 
     * @param {Array<number>} [selectedYears] 
     * @param {string} [searchSearch] 
     * @param {string} [searchSearchValue] 
     * @param {ESearchFilter} [searchSearchFilter] 
     * @param {number} [pagingPageIndex] 
     * @param {number} [pagingPageSize] 
     * @param {string} [sortingSortBy] 
     * @param {SortDirection} [sortingSortDir] 
     * @throws {RequiredError}
     * @memberof OrdersApiInterface
     */
    ordersGetCategoryOrdersForSelectedYearsGETRequestOpts(requestParameters: OrdersGetCategoryOrdersForSelectedYearsGETRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {string} [categoryId] 
     * @param {Array<number>} [selectedYears] 
     * @param {string} [searchSearch] 
     * @param {string} [searchSearchValue] 
     * @param {ESearchFilter} [searchSearchFilter] 
     * @param {number} [pagingPageIndex] 
     * @param {number} [pagingPageSize] 
     * @param {string} [sortingSortBy] 
     * @param {SortDirection} [sortingSortDir] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApiInterface
     */
    ordersGetCategoryOrdersForSelectedYearsGETRaw(requestParameters: OrdersGetCategoryOrdersForSelectedYearsGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrderDtoPagedResponseDto>>;

    /**
     */
    ordersGetCategoryOrdersForSelectedYearsGET(requestParameters: OrdersGetCategoryOrdersForSelectedYearsGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrderDtoPagedResponseDto>;

    /**
     * Creates request options for ordersGetCompanyOrdersForSelectedYearsGET without sending the request
     * @param {string} [companyId] 
     * @param {Array<number>} [selectedYears] 
     * @param {string} [searchSearch] 
     * @param {string} [searchSearchValue] 
     * @param {ESearchFilter} [searchSearchFilter] 
     * @param {number} [pagingPageIndex] 
     * @param {number} [pagingPageSize] 
     * @param {string} [sortingSortBy] 
     * @param {SortDirection} [sortingSortDir] 
     * @throws {RequiredError}
     * @memberof OrdersApiInterface
     */
    ordersGetCompanyOrdersForSelectedYearsGETRequestOpts(requestParameters: OrdersGetCompanyOrdersForSelectedYearsGETRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {string} [companyId] 
     * @param {Array<number>} [selectedYears] 
     * @param {string} [searchSearch] 
     * @param {string} [searchSearchValue] 
     * @param {ESearchFilter} [searchSearchFilter] 
     * @param {number} [pagingPageIndex] 
     * @param {number} [pagingPageSize] 
     * @param {string} [sortingSortBy] 
     * @param {SortDirection} [sortingSortDir] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApiInterface
     */
    ordersGetCompanyOrdersForSelectedYearsGETRaw(requestParameters: OrdersGetCompanyOrdersForSelectedYearsGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrderDtoPagedResponseDto>>;

    /**
     */
    ordersGetCompanyOrdersForSelectedYearsGET(requestParameters: OrdersGetCompanyOrdersForSelectedYearsGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrderDtoPagedResponseDto>;

    /**
     * Creates request options for ordersGetDashboardStatsGET without sending the request
     * @param {Date} [startDate] 
     * @param {Date} [endDate] 
     * @throws {RequiredError}
     * @memberof OrdersApiInterface
     */
    ordersGetDashboardStatsGETRequestOpts(requestParameters: OrdersGetDashboardStatsGETRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {Date} [startDate] 
     * @param {Date} [endDate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApiInterface
     */
    ordersGetDashboardStatsGETRaw(requestParameters: OrdersGetDashboardStatsGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrderDashboardStatsDto>>;

    /**
     */
    ordersGetDashboardStatsGET(requestParameters: OrdersGetDashboardStatsGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrderDashboardStatsDto>;

    /**
     * Creates request options for ordersGetOrderByIdGET without sending the request
     * @param {string} id 
     * @throws {RequiredError}
     * @memberof OrdersApiInterface
     */
    ordersGetOrderByIdGETRequestOpts(requestParameters: OrdersGetOrderByIdGETRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApiInterface
     */
    ordersGetOrderByIdGETRaw(requestParameters: OrdersGetOrderByIdGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrderDto>>;

    /**
     */
    ordersGetOrderByIdGET(requestParameters: OrdersGetOrderByIdGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrderDto>;

    /**
     * Creates request options for ordersGetOrderTotalsGET without sending the request
     * @param {string} [orderId] 
     * @param {number} [year] 
     * @throws {RequiredError}
     * @memberof OrdersApiInterface
     */
    ordersGetOrderTotalsGETRequestOpts(requestParameters: OrdersGetOrderTotalsGETRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {string} [orderId] 
     * @param {number} [year] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApiInterface
     */
    ordersGetOrderTotalsGETRaw(requestParameters: OrdersGetOrderTotalsGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrderTotal>>;

    /**
     */
    ordersGetOrderTotalsGET(requestParameters: OrdersGetOrderTotalsGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrderTotal>;

    /**
     * Creates request options for ordersGetYearlyBusinessUnitMetricsGET without sending the request
     * @param {string} [businessUnitId] 
     * @param {Array<number>} [years] 
     * @throws {RequiredError}
     * @memberof OrdersApiInterface
     */
    ordersGetYearlyBusinessUnitMetricsGETRequestOpts(requestParameters: OrdersGetYearlyBusinessUnitMetricsGETRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {string} [businessUnitId] 
     * @param {Array<number>} [years] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApiInterface
     */
    ordersGetYearlyBusinessUnitMetricsGETRaw(requestParameters: OrdersGetYearlyBusinessUnitMetricsGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: YearlyMetricsDto; }>>;

    /**
     */
    ordersGetYearlyBusinessUnitMetricsGET(requestParameters: OrdersGetYearlyBusinessUnitMetricsGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: YearlyMetricsDto; }>;

    /**
     * Creates request options for ordersGetYearlyCategoryMetricsGET without sending the request
     * @param {string} [categoryId] 
     * @param {Array<number>} [years] 
     * @throws {RequiredError}
     * @memberof OrdersApiInterface
     */
    ordersGetYearlyCategoryMetricsGETRequestOpts(requestParameters: OrdersGetYearlyCategoryMetricsGETRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {string} [categoryId] 
     * @param {Array<number>} [years] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApiInterface
     */
    ordersGetYearlyCategoryMetricsGETRaw(requestParameters: OrdersGetYearlyCategoryMetricsGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: YearlyMetricsDto; }>>;

    /**
     */
    ordersGetYearlyCategoryMetricsGET(requestParameters: OrdersGetYearlyCategoryMetricsGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: YearlyMetricsDto; }>;

    /**
     * Creates request options for ordersGetYearlyCompanyMetricsGET without sending the request
     * @param {string} [companyId] 
     * @param {Array<number>} [years] 
     * @throws {RequiredError}
     * @memberof OrdersApiInterface
     */
    ordersGetYearlyCompanyMetricsGETRequestOpts(requestParameters: OrdersGetYearlyCompanyMetricsGETRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {string} [companyId] 
     * @param {Array<number>} [years] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApiInterface
     */
    ordersGetYearlyCompanyMetricsGETRaw(requestParameters: OrdersGetYearlyCompanyMetricsGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: YearlyMetricsDto; }>>;

    /**
     */
    ordersGetYearlyCompanyMetricsGET(requestParameters: OrdersGetYearlyCompanyMetricsGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: YearlyMetricsDto; }>;

}

/**
 * 
 */
export class OrdersApi extends runtime.BaseAPI implements OrdersApiInterface {

    /**
     * Creates request options for ordersGetAllOrdersPOST without sending the request
     */
    async ordersGetAllOrdersPOSTRequestOpts(requestParameters: OrdersGetAllOrdersPOSTRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/Orders/all`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetAllOrdersFilterSortDtoToJSON(requestParameters['getAllOrdersFilterSortDto']),
        };
    }

    /**
     */
    async ordersGetAllOrdersPOSTRaw(requestParameters: OrdersGetAllOrdersPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrderDtoPagedResponseDto>> {
        const requestOptions = await this.ordersGetAllOrdersPOSTRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrderDtoPagedResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async ordersGetAllOrdersPOST(requestParameters: OrdersGetAllOrdersPOSTRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrderDtoPagedResponseDto> {
        const response = await this.ordersGetAllOrdersPOSTRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for ordersGetAvailableYearsForBusinessUnitsGET without sending the request
     */
    async ordersGetAvailableYearsForBusinessUnitsGETRequestOpts(requestParameters: OrdersGetAvailableYearsForBusinessUnitsGETRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['years'] != null) {
            queryParameters['years'] = requestParameters['years'];
        }

        if (requestParameters['businessUnitId'] != null) {
            queryParameters['businessUnitId'] = requestParameters['businessUnitId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/Orders/years-business-unit`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async ordersGetAvailableYearsForBusinessUnitsGETRaw(requestParameters: OrdersGetAvailableYearsForBusinessUnitsGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<YearsResponse>> {
        const requestOptions = await this.ordersGetAvailableYearsForBusinessUnitsGETRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => YearsResponseFromJSON(jsonValue));
    }

    /**
     */
    async ordersGetAvailableYearsForBusinessUnitsGET(requestParameters: OrdersGetAvailableYearsForBusinessUnitsGETRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<YearsResponse> {
        const response = await this.ordersGetAvailableYearsForBusinessUnitsGETRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for ordersGetAvailableYearsForCategoriesGET without sending the request
     */
    async ordersGetAvailableYearsForCategoriesGETRequestOpts(requestParameters: OrdersGetAvailableYearsForCategoriesGETRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['years'] != null) {
            queryParameters['years'] = requestParameters['years'];
        }

        if (requestParameters['categoryId'] != null) {
            queryParameters['categoryId'] = requestParameters['categoryId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/Orders/years-category`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async ordersGetAvailableYearsForCategoriesGETRaw(requestParameters: OrdersGetAvailableYearsForCategoriesGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<YearsResponse>> {
        const requestOptions = await this.ordersGetAvailableYearsForCategoriesGETRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => YearsResponseFromJSON(jsonValue));
    }

    /**
     */
    async ordersGetAvailableYearsForCategoriesGET(requestParameters: OrdersGetAvailableYearsForCategoriesGETRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<YearsResponse> {
        const response = await this.ordersGetAvailableYearsForCategoriesGETRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for ordersGetAvailableYearsGET without sending the request
     */
    async ordersGetAvailableYearsGETRequestOpts(requestParameters: OrdersGetAvailableYearsGETRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['years'] != null) {
            queryParameters['years'] = requestParameters['years'];
        }

        if (requestParameters['companyId'] != null) {
            queryParameters['companyId'] = requestParameters['companyId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/Orders/years-company`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async ordersGetAvailableYearsGETRaw(requestParameters: OrdersGetAvailableYearsGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<YearsResponse>> {
        const requestOptions = await this.ordersGetAvailableYearsGETRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => YearsResponseFromJSON(jsonValue));
    }

    /**
     */
    async ordersGetAvailableYearsGET(requestParameters: OrdersGetAvailableYearsGETRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<YearsResponse> {
        const response = await this.ordersGetAvailableYearsGETRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for ordersGetBusinessUnitsOrdersForSelectedYearsGET without sending the request
     */
    async ordersGetBusinessUnitsOrdersForSelectedYearsGETRequestOpts(requestParameters: OrdersGetBusinessUnitsOrdersForSelectedYearsGETRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['businessUnitId'] != null) {
            queryParameters['businessUnitId'] = requestParameters['businessUnitId'];
        }

        if (requestParameters['selectedYears'] != null) {
            queryParameters['selectedYears'] = requestParameters['selectedYears'];
        }

        if (requestParameters['searchSearch'] != null) {
            queryParameters['Search.Search'] = requestParameters['searchSearch'];
        }

        if (requestParameters['searchSearchValue'] != null) {
            queryParameters['Search.SearchValue'] = requestParameters['searchSearchValue'];
        }

        if (requestParameters['searchSearchFilter'] != null) {
            queryParameters['Search.SearchFilter'] = requestParameters['searchSearchFilter'];
        }

        if (requestParameters['pagingPageIndex'] != null) {
            queryParameters['Paging.PageIndex'] = requestParameters['pagingPageIndex'];
        }

        if (requestParameters['pagingPageSize'] != null) {
            queryParameters['Paging.PageSize'] = requestParameters['pagingPageSize'];
        }

        if (requestParameters['sortingSortBy'] != null) {
            queryParameters['Sorting.SortBy'] = requestParameters['sortingSortBy'];
        }

        if (requestParameters['sortingSortDir'] != null) {
            queryParameters['Sorting.SortDir'] = requestParameters['sortingSortDir'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/Orders/yearly-business-unit`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async ordersGetBusinessUnitsOrdersForSelectedYearsGETRaw(requestParameters: OrdersGetBusinessUnitsOrdersForSelectedYearsGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrderDtoPagedResponseDto>> {
        const requestOptions = await this.ordersGetBusinessUnitsOrdersForSelectedYearsGETRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrderDtoPagedResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async ordersGetBusinessUnitsOrdersForSelectedYearsGET(requestParameters: OrdersGetBusinessUnitsOrdersForSelectedYearsGETRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrderDtoPagedResponseDto> {
        const response = await this.ordersGetBusinessUnitsOrdersForSelectedYearsGETRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for ordersGetCategoryOrdersForSelectedYearsGET without sending the request
     */
    async ordersGetCategoryOrdersForSelectedYearsGETRequestOpts(requestParameters: OrdersGetCategoryOrdersForSelectedYearsGETRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['categoryId'] != null) {
            queryParameters['categoryId'] = requestParameters['categoryId'];
        }

        if (requestParameters['selectedYears'] != null) {
            queryParameters['selectedYears'] = requestParameters['selectedYears'];
        }

        if (requestParameters['searchSearch'] != null) {
            queryParameters['Search.Search'] = requestParameters['searchSearch'];
        }

        if (requestParameters['searchSearchValue'] != null) {
            queryParameters['Search.SearchValue'] = requestParameters['searchSearchValue'];
        }

        if (requestParameters['searchSearchFilter'] != null) {
            queryParameters['Search.SearchFilter'] = requestParameters['searchSearchFilter'];
        }

        if (requestParameters['pagingPageIndex'] != null) {
            queryParameters['Paging.PageIndex'] = requestParameters['pagingPageIndex'];
        }

        if (requestParameters['pagingPageSize'] != null) {
            queryParameters['Paging.PageSize'] = requestParameters['pagingPageSize'];
        }

        if (requestParameters['sortingSortBy'] != null) {
            queryParameters['Sorting.SortBy'] = requestParameters['sortingSortBy'];
        }

        if (requestParameters['sortingSortDir'] != null) {
            queryParameters['Sorting.SortDir'] = requestParameters['sortingSortDir'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/Orders/yearly-category`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async ordersGetCategoryOrdersForSelectedYearsGETRaw(requestParameters: OrdersGetCategoryOrdersForSelectedYearsGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrderDtoPagedResponseDto>> {
        const requestOptions = await this.ordersGetCategoryOrdersForSelectedYearsGETRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrderDtoPagedResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async ordersGetCategoryOrdersForSelectedYearsGET(requestParameters: OrdersGetCategoryOrdersForSelectedYearsGETRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrderDtoPagedResponseDto> {
        const response = await this.ordersGetCategoryOrdersForSelectedYearsGETRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for ordersGetCompanyOrdersForSelectedYearsGET without sending the request
     */
    async ordersGetCompanyOrdersForSelectedYearsGETRequestOpts(requestParameters: OrdersGetCompanyOrdersForSelectedYearsGETRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['companyId'] != null) {
            queryParameters['companyId'] = requestParameters['companyId'];
        }

        if (requestParameters['selectedYears'] != null) {
            queryParameters['selectedYears'] = requestParameters['selectedYears'];
        }

        if (requestParameters['searchSearch'] != null) {
            queryParameters['Search.Search'] = requestParameters['searchSearch'];
        }

        if (requestParameters['searchSearchValue'] != null) {
            queryParameters['Search.SearchValue'] = requestParameters['searchSearchValue'];
        }

        if (requestParameters['searchSearchFilter'] != null) {
            queryParameters['Search.SearchFilter'] = requestParameters['searchSearchFilter'];
        }

        if (requestParameters['pagingPageIndex'] != null) {
            queryParameters['Paging.PageIndex'] = requestParameters['pagingPageIndex'];
        }

        if (requestParameters['pagingPageSize'] != null) {
            queryParameters['Paging.PageSize'] = requestParameters['pagingPageSize'];
        }

        if (requestParameters['sortingSortBy'] != null) {
            queryParameters['Sorting.SortBy'] = requestParameters['sortingSortBy'];
        }

        if (requestParameters['sortingSortDir'] != null) {
            queryParameters['Sorting.SortDir'] = requestParameters['sortingSortDir'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/Orders/yearly-company`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async ordersGetCompanyOrdersForSelectedYearsGETRaw(requestParameters: OrdersGetCompanyOrdersForSelectedYearsGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrderDtoPagedResponseDto>> {
        const requestOptions = await this.ordersGetCompanyOrdersForSelectedYearsGETRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrderDtoPagedResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async ordersGetCompanyOrdersForSelectedYearsGET(requestParameters: OrdersGetCompanyOrdersForSelectedYearsGETRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrderDtoPagedResponseDto> {
        const response = await this.ordersGetCompanyOrdersForSelectedYearsGETRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for ordersGetDashboardStatsGET without sending the request
     */
    async ordersGetDashboardStatsGETRequestOpts(requestParameters: OrdersGetDashboardStatsGETRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['startDate'] != null) {
            queryParameters['startDate'] = (requestParameters['startDate'] as any).toISOString();
        }

        if (requestParameters['endDate'] != null) {
            queryParameters['endDate'] = (requestParameters['endDate'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/Orders/dashboard-stats`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async ordersGetDashboardStatsGETRaw(requestParameters: OrdersGetDashboardStatsGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrderDashboardStatsDto>> {
        const requestOptions = await this.ordersGetDashboardStatsGETRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrderDashboardStatsDtoFromJSON(jsonValue));
    }

    /**
     */
    async ordersGetDashboardStatsGET(requestParameters: OrdersGetDashboardStatsGETRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrderDashboardStatsDto> {
        const response = await this.ordersGetDashboardStatsGETRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for ordersGetOrderByIdGET without sending the request
     */
    async ordersGetOrderByIdGETRequestOpts(requestParameters: OrdersGetOrderByIdGETRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling ordersGetOrderByIdGET().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/Orders/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async ordersGetOrderByIdGETRaw(requestParameters: OrdersGetOrderByIdGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrderDto>> {
        const requestOptions = await this.ordersGetOrderByIdGETRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrderDtoFromJSON(jsonValue));
    }

    /**
     */
    async ordersGetOrderByIdGET(requestParameters: OrdersGetOrderByIdGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrderDto> {
        const response = await this.ordersGetOrderByIdGETRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for ordersGetOrderTotalsGET without sending the request
     */
    async ordersGetOrderTotalsGETRequestOpts(requestParameters: OrdersGetOrderTotalsGETRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['orderId'] != null) {
            queryParameters['orderId'] = requestParameters['orderId'];
        }

        if (requestParameters['year'] != null) {
            queryParameters['year'] = requestParameters['year'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/Orders/totals`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async ordersGetOrderTotalsGETRaw(requestParameters: OrdersGetOrderTotalsGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrderTotal>> {
        const requestOptions = await this.ordersGetOrderTotalsGETRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrderTotalFromJSON(jsonValue));
    }

    /**
     */
    async ordersGetOrderTotalsGET(requestParameters: OrdersGetOrderTotalsGETRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrderTotal> {
        const response = await this.ordersGetOrderTotalsGETRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for ordersGetYearlyBusinessUnitMetricsGET without sending the request
     */
    async ordersGetYearlyBusinessUnitMetricsGETRequestOpts(requestParameters: OrdersGetYearlyBusinessUnitMetricsGETRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['businessUnitId'] != null) {
            queryParameters['businessUnitId'] = requestParameters['businessUnitId'];
        }

        if (requestParameters['years'] != null) {
            queryParameters['years'] = requestParameters['years'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/Orders/yearly-businessunit-metrics`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async ordersGetYearlyBusinessUnitMetricsGETRaw(requestParameters: OrdersGetYearlyBusinessUnitMetricsGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: YearlyMetricsDto; }>> {
        const requestOptions = await this.ordersGetYearlyBusinessUnitMetricsGETRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => runtime.mapValues(jsonValue, YearlyMetricsDtoFromJSON));
    }

    /**
     */
    async ordersGetYearlyBusinessUnitMetricsGET(requestParameters: OrdersGetYearlyBusinessUnitMetricsGETRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: YearlyMetricsDto; }> {
        const response = await this.ordersGetYearlyBusinessUnitMetricsGETRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for ordersGetYearlyCategoryMetricsGET without sending the request
     */
    async ordersGetYearlyCategoryMetricsGETRequestOpts(requestParameters: OrdersGetYearlyCategoryMetricsGETRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['categoryId'] != null) {
            queryParameters['categoryId'] = requestParameters['categoryId'];
        }

        if (requestParameters['years'] != null) {
            queryParameters['years'] = requestParameters['years'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/Orders/yearly-category-metrics`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async ordersGetYearlyCategoryMetricsGETRaw(requestParameters: OrdersGetYearlyCategoryMetricsGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: YearlyMetricsDto; }>> {
        const requestOptions = await this.ordersGetYearlyCategoryMetricsGETRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => runtime.mapValues(jsonValue, YearlyMetricsDtoFromJSON));
    }

    /**
     */
    async ordersGetYearlyCategoryMetricsGET(requestParameters: OrdersGetYearlyCategoryMetricsGETRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: YearlyMetricsDto; }> {
        const response = await this.ordersGetYearlyCategoryMetricsGETRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for ordersGetYearlyCompanyMetricsGET without sending the request
     */
    async ordersGetYearlyCompanyMetricsGETRequestOpts(requestParameters: OrdersGetYearlyCompanyMetricsGETRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['companyId'] != null) {
            queryParameters['companyId'] = requestParameters['companyId'];
        }

        if (requestParameters['years'] != null) {
            queryParameters['years'] = requestParameters['years'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/Orders/yearly-company-metrics`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async ordersGetYearlyCompanyMetricsGETRaw(requestParameters: OrdersGetYearlyCompanyMetricsGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: YearlyMetricsDto; }>> {
        const requestOptions = await this.ordersGetYearlyCompanyMetricsGETRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => runtime.mapValues(jsonValue, YearlyMetricsDtoFromJSON));
    }

    /**
     */
    async ordersGetYearlyCompanyMetricsGET(requestParameters: OrdersGetYearlyCompanyMetricsGETRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: YearlyMetricsDto; }> {
        const response = await this.ordersGetYearlyCompanyMetricsGETRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
